module.exports = __webpack_public_path__ + "static/media/car.f7b5145f.jpg";